module.exports = __webpack_public_path__ + "static/tourist_1_sff-ad28ae799b31b1b0995b47e898f83ea4.jpg";